<template>
<megaMenu v-if="!isInline" :options="{minWidth: '100%'}" ref="paxPicker">
  <template v-if="isDesktop || forceDesktop">
    <div class="block font-bold border-t py-16 px-4 lg:border-l lg:border-t-0 border-grey-lighter lg:p-8 lg:ml-4 lg:pl-16 select-none cursor-pointer leading-md" @click="peopleInputClick">
      <!-- <div class="leading-md text-base border-r border-grey-darkest pr-16 mr-16 lg:border-none md pr-0 mr-0 lg:text-sm">{{ $t('searchPeople.room', [room]) }}</div> -->
      <div class="hidden md:block text-xs font-bold mr-4 text-grey-dark">{{ $t('searchPeople.title') }}</div>
      <div class="leading-md text-base">{{ displayText }}</div>
    </div>
  </template>
  <template v-else>
    <span>, {{ $t('peopleCount', {count: totalCount}) }}</span>
  </template>
  <template v-slot:dropdown>
    <!-- <searchCount v-model="room" :options="{minimum: 1, maximum: 10}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.room', []) }}</span>
      </template>
    </searchCount> -->
    <searchCount v-model="adult" :options="{minimum: 1, maximum: 36, type: 'adult'}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.adult', []) }}</span>
      </template>
    </searchCount>
    <searchCount v-model="child" :options="{minimum: 0, maximum: 10, type: 'child'}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.child', []) }}</span>
      </template>
      <template slot="extend">
        <div class="text-xs leading-xs text-grey-dark text-center">{{ $t('childAgeRange') }}</div>
      </template>
    </searchCount>
    <div class="m-16">
      <div v-show="childrenAge && childrenAge.length" class="text-sm mt-24 mb-16">{{ $t('childYearsOld') }}</div>
      <template v-for="(age, index) in childrenAge">
        <select :key="`${age}-${index}`" class="input input-sm w-full text-xs text-grey-darkests block" :value="age" @input="$set(childrenAge, index, Number($event.target.value))">
          <option v-for="option in 12" :value="option" :key="`${index}-${option}`">{{ option }}</option>
        </select>
      </template>
    </div>
    <!-- <div class="m-8 flex justify-end">
      <button class="btn btn-sm btn-solid btn-blue-light px-16">{{ $t('confirm') }}</button>
    </div> -->
  </template>
</megaMenu>
<div v-else>
  <!-- <searchCount v-model="room" :options="{minimum: 1, maximum: 10}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.room', []) }}</span>
      </template>
    </searchCount> -->
    <searchCount v-model="adult" :options="{minimum: 1, maximum: 36, type: 'adult'}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.adult', []) }}</span>
      </template>
    </searchCount>
    <searchCount v-model="child" :options="{minimum: 0, maximum: 10, type: 'child'}" class="mx-16 my-24">
      <template slot>
        <span class="leading-sm">{{ $t('searchPeople.child', []) }}</span>
      </template>
      <template slot="extend">
        <div class="text-xs leading-xs text-grey-dark text-center">{{ $t('childAgeRange') }}</div>
      </template>
    </searchCount>
    <div class="m-16">
      <div v-show="childrenAge && childrenAge.length" class="text-sm mt-24 mb-16">{{ $t('childYearsOld') }}</div>
      <template v-for="(age, index) in childrenAge">
        <select :key="`${age}-${index}`" class="input input-sm w-full mb-8 text-xs text-grey-darkests" :value="age" @input="$set(childrenAge, index, Number($event.target.value))">
          <option v-for="option in 12" :value="option" :key="`${index}-${option}`">{{ option }}</option>
        </select>
      </template>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import SimpleVueValidation from 'simple-vue-validator'

const Validator = SimpleVueValidation.Validator

export default {
  name: '',
  props: {
    forceDesktop: {
      type: Boolean
    },
    isInline: {
      type: Boolean
    }
  },
  validators: {
    'adult': function (val) {
      return Validator.value(val).greaterThan(0).required()
    }
  },
  data () {
    return {
      room: 1,
      adult: 2,
      child: 0,
      childrenAge: [],
      Initializing: true
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      isYokosoHotel: 'yokoso/isYokosoHotel'
    }),
    displayText: function () {
      const adult = this.$t('searchPeople.adult', [this.adult])
      const child = this.$t('searchPeople.child', [this.child])
      return `${adult} ${child}`
    },
    totalCount: function () {
      const people = [this.adult, this.child]
      return people.reduce((x, y) => x + y)
    }
  },
  methods: {
    doValidate: function () {
      return this.$validate().then(success => {
        if (success) {
          return Promise.resolve({
            adult: this.adult,
            child: this.child,
            room: this.room,
            childrenAge: this.childrenAge
          })
        } else {
          this.focusHandler()
          throw this.validation
        }
      })
    },
    focusHandler: function () {
      if (this.isDesktop || this.forceDesktop) {
        this.$refs.paxPicker.focusHandler()
      }
    },
    peopleInputClick: function () {
      if (this.$route.name === 'Home') {
        window.dataLayer.push({
          event: 'index_searchbar_people'
        })
      } else {
        window.dataLayer.push({
          event: 'list_searchbar_people'
        })
      }
    }
  },
  watch: {
    child: {
      handler: function (val, oldVal) {
        if (!oldVal || oldVal < val) {
          console.debug('child +')
          if (!this.Initializing) {
            this.childrenAge.push(12)
          }
        } else {
          console.debug('child -')
          this.childrenAge.pop()
        }
      }
    },
    $route: {
      handler: async function ($route) {
        if ($route.query?.room) {
          await this.$set(this, 'room', Number($route.query.room))
        } else {
          await this.$set(this, 'room', 1)
        }
        if ($route.query?.adult) {
          await this.$set(this, 'adult', Number($route.query.adult))
        } else {
          await this.$set(this, 'adult', 2)
        }
        if ($route.query?.child) {
          await this.$set(this, 'child', Number($route.query.child))
        } else {
          await this.$set(this, 'child', 0)
        }
        if ($route.query?.ages?.split(',').length > 0) {
          await this.$set(this, 'childrenAge', $route.query.ages.split(',').map(x => +x))
        } else {
          await this.$set(this, 'childrenAge', [])
        }
        this.Initializing = false
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
select
  @apply px-8 py-4 text-grey-darker text-sm my-4
  background: url('~@/assets/dropdown.svg') no-repeat right #f2f4f6
  -webkit-appearance: none
  background-position-x: calc(100% - 16px)
</style>
